import { Expose, Type } from "class-transformer";
import { UpdatePurchaseApprovalLineDto } from "@/core/features/purchase-orders/update-purchase-approval-line.dto";

export class UpdatePurchaseApprovalConfigurationDto {
  @Expose()
  @Type(() => UpdatePurchaseApprovalLineDto)
  config: UpdatePurchaseApprovalLineDto[];
}
